import { color, font } from './tokens';

const kebab = (key: string) => key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);

/**
 * Publishes the design tokens as CSS variables (e.g. `--tempo-coral`, `--tempo-text-muted`)
 * so global.css uses the same values as the antd theme and inline styles.
 */
export function applyCssVariables(): void {
  const lines = Object.entries(color).map(([key, value]) => `--tempo-${kebab(key)}: ${value};`);
  lines.push(`--tempo-font-ui: ${font.ui};`, `--tempo-display-stretch: ${font.displayStretch};`);
  const style = document.createElement('style');
  style.id = 'tempo-tokens';
  style.textContent = `:root {\n  ${lines.join('\n  ')}\n}`;
  document.head.appendChild(style);
}
